import React from 'react'
import {useFlags} from 'launchdarkly-react-client-sdk'
import {formatPrice} from '../../utils/currency-format'
import {calculateCouponsAmountForItem} from '../../utils/coupon-helpers'
import {SOCIAL_ADS_BNI_PLAN_CODES, GST_MULTIPLIERS} from '../../utils/constants'

function getPreviewSubtotal(item, isAusNZ, country) {
  let subtotal
  if (item.planCode === 'mc_pro_enh-5-thryv-m2m') {
    subtotal = item.subtotal - item.discount
  } else {
    subtotal = !isAusNZ ? item.subtotal : item.subtotal + item.tax
  }
  return formatPrice(subtotal, 1, '', country)
}

function ProductItem({
  currentItem,
  showIncentive = false,
  incentiveCoupon,
  isOneTimeFee = false,
  upgradePaymentPreview,
  country,
  crossedOut,
  isCohort,
  orderCouponCodes,
}) {
  if (currentItem?.code?.includes('social') && upgradePaymentPreview) {
    console.log(currentItem)
  }
  const {frontendListingsBcMc} = useFlags()
  // console.log({upgradePaymentPreview, currentItem, orderCouponCodes})
  let previewItem = upgradePaymentPreview?.centers?.find(
    ({planCode}) => planCode === currentItem.code,
  )

  if (!previewItem) {
    previewItem = upgradePaymentPreview?.apps?.find(
      ({planCode, addonCode}) =>
        planCode === currentItem.code || addonCode === currentItem.code,
    )
  }

  if (!previewItem) {
    previewItem = upgradePaymentPreview?.oneTimes?.find(
      ({planCode}) => planCode === currentItem.code,
    )
  }
  const isAusNZ = ['AU', 'NZ'].includes(country)

  const getItemName = () => {
    const shouldShowQtyForRecurring =
      currentItem.name.includes('Social Ads') ||
      currentItem.name.includes('AI Website Builder')

    if (!isOneTimeFee) {
      if (shouldShowQtyForRecurring) {
        return `${currentItem.name} ${
          currentItem.quantity > 1 ? `(${currentItem.quantity}x)` : ''
        }`
      }
      return currentItem.name
    }

    return `${currentItem.name} ${
      currentItem.quantity > 1 ? `(${currentItem.quantity}x)` : ''
    }`
  }

  const getAmount = () => {
    // GEP-6803: BNI is read-only display (provisioned in Salesforce, not
    // managed in OOE) — always render "Included" regardless of upgrade
    // preview state so the price never rolls into the catalog Total.
    if (
      !isOneTimeFee &&
      SOCIAL_ADS_BNI_PLAN_CODES.includes(currentItem?.code)
    ) {
      return 'Included'
    }
    const isInArray = arr =>
      arr?.some(({planCode, addonCode}) => {
        let planType
        if (
          currentItem.code === 'seobase-5-thryv-m2m' ||
          currentItem.code === 'addon-5-seokey-m2m' ||
          currentItem.code === 'addon-5-seopb-m2m' ||
          currentItem.code === 'addon-5-keap-addcontacts-m2m' ||
          currentItem.code === 'addon-5-keap-textvoice-m2m' ||
          currentItem.code === 'addon-5-keap-addusers-m2m' ||
          currentItem.code === 'addon-5-keap-addcontacts-annual' ||
          currentItem.code === 'addon-5-keap-textvoice-annual' ||
          currentItem.code === 'addon-5-keap-addusers-annual' ||
          currentItem.code === 'addon-5-website_difm'
        ) {
          planType = 'app'
        } else {
          planType = currentItem.planType
        }

        if (planType !== 'app') return currentItem.code === planCode
        else if (planType === 'app') {
          if (
            currentItem.code === 'keap_max-5-thryv-m2m' ||
            currentItem.code === 'vert_mc_clientsvcs-5-thryv-m2m' ||
            currentItem.code === 'vert_mc_web_clientsvcs-5-thryv-m2m' ||
            currentItem.code === 'vert_clientsvcs-5-thryv-m2m' ||
            currentItem.code === 'vert_mc_clientsvcs-5-thryv-ot' ||
            currentItem.code === 'vert_mc_web_clientsvcs-5-thryv-ot' ||
            currentItem.code === 'vert_clientsvcs-5-thryv-ot' ||
            currentItem.code === 'vert_svcs-5-thryv-m2m' ||
            currentItem.code === 'proservices-m2m' ||
            currentItem.code === 'addon-5-leadslift-m2m' ||
            currentItem.code === 'tl-mc-5-thryv-m2m' ||
            currentItem.code === 'tl-5-thryv-m2m' ||
            currentItem.code === 'tl-tax-5-thryv-m2m'
          ) {
            return currentItem.code === planCode
          } else {
            return currentItem.code === addonCode
          }
        }
      })
    const isNewCenter = isInArray(upgradePaymentPreview?.centers)
    const isNewApp = isInArray(upgradePaymentPreview?.apps)

    if (upgradePaymentPreview) {
      let isAlphaSeoUpgrade = false
      const alphaSeoPreview = upgradePaymentPreview.apps.find(
        ({planCode, addonCode}) =>
          !addonCode && planCode === 'seobase-5-thryv-m2m',
      )
      if (currentItem.code === 'seobase-5-thryv-m2m' && alphaSeoPreview) {
        isAlphaSeoUpgrade = true
      }

      const isSocialAds = currentItem.code.includes('addon-socialads')
      const isTSS = [
        'addon-5-stratcontent-m2m',
        'addon-5-listrefrsh-m2m',
      ].includes(currentItem.code)
      const isAiWebSite = currentItem.code.includes('addon-5-ai-webbuilder')
      const isLeadsLiftBNI = currentItem.code === 'addon-5-leadslift-bni-m2m'
      if (
        !isNewCenter &&
        !isNewApp &&
        !isOneTimeFee &&
        !isAlphaSeoUpgrade &&
        !isSocialAds &&
        !isTSS &&
        !isAiWebSite &&
        !isLeadsLiftBNI
      ) {
        return 'Included'
      }
      if (isNewCenter) {
        const center = upgradePaymentPreview.centers.find(
          ({planCode}) => planCode === currentItem.code,
        )
        return center && `${getPreviewSubtotal(center, isAusNZ, country)}`
      }
      if (!isOneTimeFee) {
        const app =
          upgradePaymentPreview.apps.find(
            ({addonCode, planCode}) =>
              (addonCode || planCode) === currentItem.code,
          ) ||
          upgradePaymentPreview.centers.find(
            ({planCode}) => planCode === currentItem.code,
          )
        return app
          ? `${getPreviewSubtotal(app, isAusNZ, country)}`
          : formatPrice(0, 1, '', country)
      } else {
        const oneTimeFee = upgradePaymentPreview.oneTimes.find(
          ({planCode}) => planCode === currentItem.code,
        )
        return (
          oneTimeFee && `${getPreviewSubtotal(oneTimeFee, isAusNZ, country)}`
        )
      }
    }

    if (
      ['addon-5-stratcontent-m2m', 'addon-5-listrefrsh-m2m'].includes(
        currentItem.code,
      ) &&
      currentItem.tempLineActionCode === 'New'
    ) {
      return formatPrice(0, currentItem.quantity, currentItem.name, country)
    }
    return formatPrice(
      crossedOut
        ? 0
        : currentItem?.code === 'addon-5-leadslift-m2m'
        ? currentItem.unitAmount
        : currentItem?.amount,
      currentItem.quantity,
      currentItem.name,
      country,
    )
  }
  const getDiscountedAmount = () => {
    if (upgradePaymentPreview) {
      return previewItem?.discount
    } else {
      // prodType for coupon calculation is based on coupon properties:
      // appliesToAllPlans, appliesToAllItems, appliesToNonPlanCharges
      // Note: all apps are addons and all centers are plans, and for Recurly all addons are items based
      let prodType
      if (isOneTimeFee) {
        prodType = 'oneTimeFee'
      } else if (
        currentItem?.planType === 'center' ||
        currentItem?.code === 'tl-tax-5-thryv-m2m'
      ) {
        prodType = 'plan'
      } else if (currentItem?.planType === 'app') {
        prodType = 'itemBasedAddon'
      }

      const itemDetails = {
        code: currentItem?.code,
        prodType,
        planCode: currentItem?.parentProduct,
        currency: {
          unitAmount: currentItem?.unitAmount ?? currentItem?.amount ?? 0,
        },
        quantity:
          currentItem?.code === 'tl-tax-5-thryv-m2m'
            ? 1
            : currentItem?.quantity ?? 1,
      }

      // FULSAS-9880: one-time fees are displayed GST-inclusive in AU, but a
      // fixed-amount waiver coupon (e.g. Waive Onboarding Fee) arrives from
      // Recurly tax-exclusive. Gross the fixed discount up to GST-inclusive so
      // the incentive line matches the fee it waives (e.g. -$350, not -$318.18).
      const gstMultiplier = isOneTimeFee ? GST_MULTIPLIERS[country] ?? 1 : 1

      return calculateCouponsAmountForItem(
        itemDetails,
        orderCouponCodes || [],
        gstMultiplier,
      ).discountAmount
    }
  }

  const renderIncentive = !!(
    (!isCohort && showIncentive && getDiscountedAmount() > 0) ||
    (previewItem?.discount &&
      currentItem.code !== 'mc_pro_enh-5-thryv-m2m' &&
      currentItem.code !== 'appmarket-5-thryv-m2m' &&
      getDiscountedAmount() > 0)
  )

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          {!isOneTimeFee && (
            <img
              alt={currentItem.name}
              style={{
                width: '25px',
                height: '25px',
                borderRadius: '5px',
                marginRight: '0.5rem',
              }}
              src={currentItem.img}
            />
          )}
          <p
            style={{
              color: crossedOut && frontendListingsBcMc ? '#808080' : '',
              textDecorationLine:
                crossedOut && frontendListingsBcMc ? 'line-through' : 'none',
            }}
          >
            {getItemName()}
          </p>
        </div>
        <p className="mr-2">{getAmount()}</p>
      </div>
      {renderIncentive && (
        <div className="d-flex justify-content-between">
          <div className="d-flex">
            {incentiveCoupon?.code === 'nci'
              ? 'One Month Free'
              : 'Total Incentive'}
          </div>
          <p className="mr-2">
            -{formatPrice(getDiscountedAmount(), 1, '', country)}
          </p>
        </div>
      )}
    </>
  )
}

export {ProductItem}
